import { CheckoutPaymentTypes } from '../checkout/checkout-payment-types.interface';
import { PaymentFrequency } from '../config/payment-frequency.enum';

export interface ProtectionDetailsPaymentOption {
  paymentFrequency: PaymentFrequency;
  [key: string]: CheckoutPaymentTypes | string | number | boolean | undefined;
}
